module.exports = __webpack_public_path__ + "static/media/tpp_link_xl.0bea2fd2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tpp_link_xl.svg
// module id = 745
// module chunks = 21